import {useMemo} from 'react';
import {useGetCalendrierQuery, useGetDisponibilitesQuery} from "../../../modules/simulations/simulations.api";
import {calendrierPresent, decisionCalendrier} from "./simulationRules";

/**
 * État du calendrier de collecte d'un patrimoine. Source : `GET /simulations/calendriers?patrimoine=` (lot API 2c) ;
 * repli sur l'ancien test `disponibilites` (1 jour, `pavs` vide = aucun calendrier) uniquement si l'endpoint répond 404.
 * `currentData` : jamais les chiffres du patrimoine précédent pendant un changement de patrimoine.
 * @returns {{loading: boolean, erreur: boolean, present: boolean, details: object|null}}
 */
export function useEtatCalendrier(patrimoineId) {
    const jour = useMemo(() => new Date().toISOString().slice(0, 10), []);
    const cal = useGetCalendrierQuery(patrimoineId, {skip: !patrimoineId});
    const decision = decisionCalendrier({
        isError: cal.isError, status: cal.error?.status, currentData: cal.currentData, isFetching: cal.isFetching,
    });
    const repli = useGetDisponibilitesQuery(
        {patrimoine: patrimoineId, du: jour, au: jour, contraint: true},
        {skip: !patrimoineId || decision.mode !== 'repli'},
    );
    if (decision.mode === 'repli') {
        const pret = repli.currentData !== undefined;
        return {loading: !pret && !repli.isError, erreur: repli.isError, present: calendrierPresent(repli.currentData), details: null};
    }
    if (decision.mode === 'erreur') return {loading: false, erreur: true, present: false, details: null};
    if (decision.mode === 'chargement') return {loading: true, erreur: false, present: false, details: null};
    return {loading: false, erreur: false, present: Boolean(decision.details?.present), details: decision.details};
}
